import { Pipe, PipeTransform } from '@angular/core';
import { Reservation } from '@model/reservation';
import { UtilsService } from 'src/app/lib/utils.service';

@Pipe({
  name: 'reservationsInfo',
})
export class ReservationsInfoPipe implements PipeTransform {

  constructor(
    private utilsService: UtilsService,
  ) { }

  transform(reservations: Reservation[], ...args: unknown[]): {
    totalCovers: number,
    totalRes: number,
    pendingRes: number,
    pendingCovers: number
  } {
    return this.utilsService.calculateBlocking(reservations, true);
  }

}
